import { useEffect } from 'react';
import { AutorizadoAnualBarra, IniciadoAnualBarra, IniciadoAutorizadoAnualBarraApilada } from '../components';
import { Grid } from '@mui/material';
import { useInternacionesTramitesPorDelegacionData } from '../hooks';

const initData = {
  // idDivision: 5,
  // idTipoCobertura: 166,
};

export const InternacionesTramitesPorDelegacion = () => {
  const { fechaAnioActual, getTramitesPorDelegacionAnualList, tramitesPorDelegacionAnualList } =
    useInternacionesTramitesPorDelegacionData({
      ...initData,
    });

  useEffect(() => {
    getTramitesPorDelegacionAnualList();
  }, []);

  return (
    <>
      <Grid item xs={12} md={6}>
        <IniciadoAnualBarra date={fechaAnioActual} data={tramitesPorDelegacionAnualList} />
      </Grid>
      <Grid item xs={12} md={6}>
        <AutorizadoAnualBarra date={fechaAnioActual} data={tramitesPorDelegacionAnualList} />
        {/* <IniciadoAutorizadoAnualBarraApilada
          date={fechaAnioActual}
          data={tramitesPorDelegacionAnualList}
        /> */}
      </Grid>
    </>
  );
};
